import { useQuery } from '@tanstack/react-query';
import { Firmware } from '@ixicare/resources';

export const FIRMWARES_QUERY_KEY = ['firmwares'];

export const useFirmwares = () =>
  useQuery({
    queryKey: FIRMWARES_QUERY_KEY,
    queryFn: () => Firmware.getFirmwares(),
  });
